<script>
    import { credits, info } from '../store';
    import { numberFormatter, tooltip } from '../functions';
    import _ from 'lodash';
    import Step1 from './Step1.svelte';
    import Step3 from './Step3.svelte';
    import Tooltip from './Tooltip.svelte';

    export let step;
    export let stepComponent;

    let disabled = true;

    const addCredit = () => {
        $credits = [...$credits,
            {
                name: '',
                loan_amount: '',
                duration: '',
                interest_rate: '',
                interest_rate_annually: 0,
                monthly_payment: 0,
                amount_paid: 0,
                interest_paid: 0,
            }
        ];
    };

    $: $credits, calculateLevelOfIndebtedness();
    $: $info, checkStatus();

    function calculateLevelOfIndebtedness () {
        $info.level_indebtedness = (_.sumBy($credits, 'monthly_payment') / $info.income) * 100;
    }

    function checkStatus () {
        disabled = !$info.level_indebtedness > 0;
    }

    function prev () {
        step = 1;
        stepComponent = Step1;
    }

    function next () {
        $credits = _.filter($credits, function (credit, index) {
            return credit.monthly_payment > 0;
        });

        step = 3;
        stepComponent = Step3;
    }

    function deleteCredit (i) {
        $credits = _.filter($credits, function (credit, index) {
            return index !== i;
        });
    }
</script>

<main>
    <div class="calculator-banometru-card active" id="card-2">
        <div class="text-center color-mov mb-2">
            <h2>Ce credite am?</h2>
        </div>

        <div class="container-1000">
            <div class="text-center color-mov mb-4">
                Bună {$info.name}, hai să vedem ce oameni au avut încredere în tine și ți-au împrumutat bani :)
                <br>
                Apropo, datele nu părăsesc calculatorul tău. Altfel spus, doar tu le poți vedea.
                <br><br>
                <span class="color-orange">Atenționare!</span> “Sumele împrumutate trebuie să fie toate în aceeași monedă și în aceeași monedă cu Venitul. Exemplu: dacă am venit de 4.000 lei și un credit de 5.000 lei și unul de 5.000 euro, la creditul de 5.000 euro voi pune 5.000 euro x 4,90 lei/euro = 24.500 lei.”
            </div>

            <div class="table-responsive">
                <table class="table">
                    <thead>
                    <tr>
                        <th></th>
                        <th>Nume credit</th>
                        <th>Suma</th>
                        <th>Durata (luni)</th>
                        <th>Rata dobânzii</th>
                        <th>Rata lunară</th>
                        <th>Suma totală</th>
                        <th>Dobânda plătită</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each $credits as credit, i}
                        <tr>
                            <td>
                                <button class="btn btn-xs btn-danger" on:click|preventDefault={() => deleteCredit(i)}>Șterge</button>
                            </td>
                            <td><input type="text" class="input-table small" bind:value={credit.name} placeholder="Credit {i + 1}"></td>
                            <td><input type="number" class="input-table text-right" bind:value={credit.loan_amount} placeholder="0"></td>
                            <td><input type="number" class="input-table small text-center" bind:value={credit.duration} placeholder="0"></td>
                            <td><input type="number" class="input-table text-right" bind:value={credit.interest_rate} placeholder="0"></td>
                            <td><input type="text" class="input-table text-right" readonly value={numberFormatter(credit.monthly_payment)}></td>
                            <td><input type="text" class="input-table text-right" readonly value={numberFormatter(credit.amount_paid)}></td>
                            <td><input type="text" class="input-table text-right" readonly value={numberFormatter(credit.interest_paid)}></td>
                        </tr>
                    {/each}
                    <tr class="last-row">
                        <td></td>
                        <td><strong>TOTAL</strong></td>
                        <td><input type="text" class="input-table text-right" readonly value={numberFormatter(_.sumBy($credits,'loan_amount'))}></td>
                        <td></td>
                        <td></td>
                        <td><input type="text" class="input-table text-right" readonly value={numberFormatter(_.sumBy($credits,'monthly_payment'))}></td>
                        <td><input type="text" class="input-table text-right" readonly value={numberFormatter(_.sumBy($credits,'amount_paid'))}></td>
                        <td><input type="text" class="input-table text-right" readonly value={numberFormatter(_.sumBy($credits,'interest_paid'))}></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="row align-items-center justify-content-between">
                <div class="col-sm-auto mb-3 text-center">
                    <button class="buton has-ico" on:click="{addCredit}">ADAUGĂ <i class="icon-cust-arrow-circle-plus-01"></i></button>
                </div>
                <div class="col-sm-auto mb-3 text-center">
                    <button class="buton  has-ico bt-next-step" disabled={disabled} on:click="{next}">Pasul următor <i class="icon-cust-arrow-circle-right"></i></button>
                </div>
            </div>

            <div class="text-center color-mov">Ai un grad de îndatorare de {numberFormatter($info.level_indebtedness)}% care este
                {#if $info.level_indebtedness <= 10}
                    scăzut.
                {:else if $info.level_indebtedness > 10 && $info.level_indebtedness <= 30}
                    mediu.
                {:else if $info.level_indebtedness > 30 && $info.level_indebtedness <= 40}
                    la limită.
                {:else if $info.level_indebtedness > 40 && $info.level_indebtedness <= 50}
                    peste limita normală.
                {:else if $info.level_indebtedness > 50}
                    mult peste limita normală și legală.
                {/if}

                <span style="font-size: 14px;" use:tooltip={{content: Tooltip, text: 'Gradul de îndatorare arată cât de mult din venitul lunar al unei persoane se duce pe plata datoriilor. Se calculează împărțind totalul sumelor lunare de plată către instituții de credit la total venituri.'}}><i class="icon-info-circled" style="cursor: pointer;"></i><br></span>
            </div>

        </div>

        <div class="card-nav">
            <div class="bt-nav-calculator bt-prev bt-prev-step" on:click={prev}>
                <div class="lab">Pasul anterior</div>
                <div class="icon"></div>
            </div>
        </div>
    </div>
</main>
